class FileUploaderCtrl {
  constructor($q, FileUploaderService, $element) {
    'ngInject';
    this.$q = $q;
    this.FileUploaderService = FileUploaderService;

    this.$el = $element.find('.file-uploader');
    this.$fileInput = this.$el.find('.file-uploader__file');
    this.hoverClass = "file-uploader--drag-hover";
    this.uploadingClass = "file-uploader--is-reading";
    this.imageExtensions = ['gif', 'jpg', 'jpeg', 'bmp', 'png', 'webp'];

    this.handleFileSelect = this.handleFileSelect.bind(this);
  }

  $onInit() {
    // File inputs don't play well with Angular (i.e. no 'ng-change' events)
    this.$el
      .on('drag dragstart dragend dragover dragenter dragleave drop', (e) => {
        e.preventDefault();
        e.stopPropagation();
      })
      .on('dragover dragenter', (e) => { this.$el.addClass(this.hoverClass); })
      .on('dragleave dragend drop', (e) => { this.$el.removeClass(this.hoverClass); })
      .on('drop', this.handleFileSelect);

    this.$fileInput.on('change', this.handleFileSelect);
  }

  handleFileSelect(e) {
    var files;
    var fileReadPromises = [];

    if (e.type == 'drop') {
      files = e.originalEvent.dataTransfer.files;
    } else if (e.type == 'change') {
      files = e.target.files;
    }

    this.$el.addClass(this.uploadingClass);

    angular.forEach(files, (file) => {
      fileReadPromises.push(this.readFile(file));
    });

    this.$q.all(fileReadPromises).then(() => {
      this.$el.removeClass(this.uploadingClass);
      this.$fileInput.val(null);
    });
  }
  
  shouldOptimizeImage(file) {
    return !this.originalSize 
      && this.formatString === 'image' 
      && this.fieldDimensions !== undefined 
      && this.pageDimensions !== undefined
      && this.imageExtensions.includes(file.name.toLowerCase().split('.').pop());
  }

  readFile(file) {
    const dfd = this.$q.defer();
    const reader = new FileReader();
    const fileName = this.FileUploaderService.sanitizeFilename(file.name);
    const optimizeImage = this.shouldOptimizeImage(file);
    
    reader.onload = (loadEvent) => {

      const resolveFile = (body, filename, ignoreEncoding=true) => {
        const { customId } = this;
        const encFile = {body, filename, ignoreEncoding};
        if (this.returnRawAndEncoded) {
          this.onFileRead({rawFile: file, encFile, customId});
        } else {
          this.onFileRead({file: encFile, customId});
        }
        dfd.resolve();
      }
        
      if (optimizeImage) {
        let origImage = new Image();
        origImage.src = reader.result;
        origImage.onload = () => {
          const canvas = document.createElement('canvas');
          // Max width: calculated from widths of field, window and page background
          const widthProportion = (this.fieldDimensions.width / $(window).width());
          const maxWidth = Math.max(this.fieldDimensions.width, this.pageDimensions.width * widthProportion);
          let {height, width} = origImage;
          
          if (width > maxWidth) {
            height = height * (maxWidth / width);
            width = maxWidth;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
          ctx.drawImage(origImage, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const base64Image = dataUrl.substring(dataUrl.indexOf(',') + 1);

          resolveFile(base64Image, fileName);

        }
      } else {
        let binary = "";
        const bytes = new Uint8Array(loadEvent.target.result);
        const length = bytes.byteLength;
        for (var i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        const base64Image = btoa(binary);
        resolveFile(base64Image, fileName);
      }
    };

    optimizeImage ? reader.readAsDataURL(file) : reader.readAsArrayBuffer(file);

    return dfd.promise;
  }
}

export default {
  bindings: {
    onFileRead: "&",
    customId: "<",
    accept: "<",
    returnRawAndEncoded: "<",
    fieldDimensions: "<?",
    pageDimensions: "<?",
    formatString: "<?",
    originalSize: "<?"
  },
  templateUrl: "form-builder/utilities/file-uploader/file-uploader/file-uploader.component.html",
  controller: FileUploaderCtrl
}